module.exports = __webpack_public_path__ + "static/img/black_logo_pdf.1064774f.png";